import {Component, OnDestroy} from "@angular/core";
import {Business} from "../../model/business";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Subscription} from "rxjs";

@Component({
  selector: 'dashboard-page',
  template: require('./dashboard-page.component.html'),
  styles: [
    require('./dashboard-page.component.scss')
  ]
})

export class DashboardPageComponent implements OnDestroy {

  business: Business = new Business();

  private businessSubscription: Subscription = null;

  ngOnDestroy(): void {
    if (this.businessSubscription != null) {
      this.businessSubscription.unsubscribe();
    }
  }

  constructor(private currentBusinessService: CurrentBusinessService) {

    if (currentBusinessService.currentBusiness != null &&
      currentBusinessService.currentBusiness.logoPath != null) {
      this.business = currentBusinessService.currentBusiness;
    } else {
      this.businessSubscription = currentBusinessService.businessChange$.subscribe(
        business => this.business = business
      )
    }

  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/dashboard/dashboard-page.component.ts